import each from 'lodash/each';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import uniq from 'lodash/uniq';
// Must be imported differently because 'as' was not working
const lodash_filter = require('lodash/filter');

// **************
//  CHORD MAPPER
// **************
function chordMpr(data) {
  const mpr = {};
  const mmap = {};
  let n = 0;
  let matrix = [];
  let filter;
  let accessor;

  mpr.setFilter = (fun) => {
    filter = fun;
    return this;
  };
  mpr.setAccessor = (fun) => {
    accessor = fun;
    return this;
  };
  mpr.getMatrix = () => {
    matrix = [];
    each(mmap, (a) => {
      if (!matrix[a.id]) matrix[a.id] = [];
      each(mmap, (b) => {
        const recs = lodash_filter(data, (row) => {
          return filter(row, a, b);
        });
        matrix[a.id][b.id] = accessor(recs, a, b);
      });
    });
    return matrix;
  };
  mpr.getMap = () => mmap;
  mpr.printMatrix = () => {
    each(matrix, () => {});
  };
  mpr.addToMap = (value, info) => {
    if (!mmap[value]) {
      mmap[value] = { name: value, id: n++, data: info };
    }
  };
  mpr.addValuesToMap = (varName, info) => {
    const values = uniq(map(data, varName));
    map(values, (v) => {
      if (!mmap[v]) {
        mmap[v] = { name: v, id: n++, data: info };
      }
    });
    return this;
  };
  return mpr;
}
// **************
//  CHORD READER
// **************
function chordRdr(matrix, mmap) {
  return (d) => {
    let i = {};
    let j = {};
    let s = {};
    let t = {};
    let g = {};
    const m = {};
    if (d.source) {
      i = d.source.index;
      j = d.target.index;
      s = lodash_filter(mmap, { id: i });
      t = lodash_filter(mmap, { id: j });
      m.sname = s[0].name;
      m.sdata = d.source.value;
      m.svalue = +d.source.value;
      m.stotal = reduce(
        matrix[i],
        (k, n) => {
          k + n;
        },
        0
      );
      m.tname = t[0].name;
      m.tdata = d.target.value;
      m.tvalue = +d.target.value;
      m.ttotal = reduce(
        matrix[j],
        (k, n) => {
          k + n;
        },
        0
      );
    } else {
      g = lodash_filter(mmap, { id: d.index });
      m.gname = g[0].name;
      m.gdata = g[0].data;
      m.gvalue = d.value;
    }
    m.mtotal = reduce(
      matrix,
      (m1, n1) => {
        m1 +
          reduce(
            n1,
            (m2, n2) => {
              m2 + n2;
            },
            0
          );
      },
      0
    );
    if (m.gdata) {
      const initials = m.gdata
        .split(' ')
        .map((n) => n[0])
        .join('.');
      m.gdata = initials;
    }
    return m;
  };
}

function groupTip(d) {
  return `${d.gdata} Activities: <br/> Total comments given: ${d.gvalue}`;
  // + 'Total comments given: ' + d.gvalue + '<br/>'
  // + p(d.gvalue/d.mtotal) + ' of the total of comments (' + d.mtotal + ')'
}

function chordKey(data) {
  return data.source.index < data.target.index
    ? `${data.source.index}-${data.target.index}`
    : `${data.target.index}-${data.source.index}`;
}

function createMatrixAndMap(data) {
  const mpr = chordMpr(data);
  each(data, (submission) => {
    mpr.addToMap(submission.user_id, submission.user_name);
  });
  mpr.setFilter((row, a) => row.user_id === a.name);
  mpr.setAccessor((recs, a, b) => {
    if (!recs[0]) return 0;
    let n = 0;
    each(recs, (r) => {
      each(r.users_I_have_commented_to, (i) => {
        if (i === b.name && i !== a.name) n += 1;
      });
    });
    return n;
  });
  return {
    matrix: mpr.getMatrix(),
    map: mpr.getMap(),
  };
}

function chordMprVerbal(data) {
  const mpr = {};
  const mmap = {};
  let n = 0;
  let matrix = [];
  let filter;
  let accessor;

  mpr.setFilter = (fun) => {
    filter = fun;
    return this;
  };
  mpr.setAccessor = (fun) => {
    accessor = fun;
    return this;
  };
  mpr.getMatrix = () => {
    matrix = [];
    each(mmap, (a) => {
      if (!matrix[a.id]) matrix[a.id] = [];
      each(mmap, (b) => {
        const recs = lodash_filter(data, (row) => {
          return filter(row, a, b);
        });
        matrix[a.id][b.id] = accessor(recs, a, b);
      });
    });
    return matrix;
  };
  mpr.getMap = () => mmap;
  mpr.printMatrix = () => {
    each(matrix, () => {});
  };
  mpr.addToMap = (value, info) => {    if (!mmap[value]) {
      mmap[value] = { name: value, id: n++, data: info };
    }
  };
  mpr.addValuesToMap = (varName, info) => {
    const values = uniq(map(data, varName));
    map(values, (v) => {
      if (!mmap[v]) {
        mmap[v] = { name: v, id: n++, data: info };
      }
    });
    return this;
  };
  return mpr;
}

function createMatrixAndMapVerbal(data) {
  const mpr = chordMprVerbal(data);
  each(data, (participation) => {
    mpr.addToMap(participation.participation_id, participation.user_name);
  });
  mpr.setFilter((row, a) => row.participation_id === a.name);
  mpr.setAccessor((recs, a, b) => {
    if (!recs[0]) return 0;
    let n = 0;
    each(recs, (r) => {
      each(r.turns_I_response, (i) => {
        if (i.participation_id === b.name && i.participation_id !== a.name) n += 1;
      });
    });
    return n;
  });
  return {
    matrix: mpr.getMatrix(),
    map: mpr.getMap(),
  };
}

export { chordMpr, chordRdr, groupTip, chordKey, createMatrixAndMap, createMatrixAndMapVerbal };



// WEBPACK FOOTER //
// ./src/app/components/dataVisualization/d3js/chordHelperFunctions.js